import React from "react";
import { Row, Col } from "reactstrap";


const RetornoSmartPed = ({ retorno, onChangePedir }) => {

  const totalDist = (codDist) =>{
    let total = 0;
    
    retorno.itens.map(item=>{
      item.Condicoes.map(cond=>{
        if((cond.codigo == codDist) && (cond.pedir == 'S')){
          total += (cond.valor * item.Quantidade);
        }
      })
    })
    return(total.toFixed(2));
  }

  return (
    <>
      
        <Row className="border-top border-left border-right mt-3">
          <Col>
            <h6 className="font-weight-bold text-center mb-0 py-2" style={{ textWrapMode: 'nowrap' }} >Retorno SmartPed</h6>
          </Col>
        </Row>

        {/* <Row> */}
        <Row className="border-top border-left border-right">
          <Col className="justify-content-center header-column-cell  "><p className="mb-0 font-weight-bold text-center">Cód Barras</p></Col>
          <Col className="justify-content-center header-column-cell "><p className="mb-0 font-weight-bold text-center">Produto</p></Col>
          {retorno.dists && retorno.dists.map(dist =>
            <Col className="justify-content-center header-column-cell "><p className="mb-0 font-weight-bold text-center">{dist.nome}</p></Col>
          )}
        </Row>
        {/* </Row> */}

        {/* <Row> */}

        {retorno.itens && retorno.itens.map((item, idx) =>
          <Row className={"d-flex border-top border-left border-right" + ((idx % 2 != 0) ? ' row-color ' : '')}>
            <Col className="d-flex justify-content-center column-cell py-0 "><p className="mb-0 text-center">{item.CodBarra}</p></Col>
            <Col className="d-flex justify-content-center column-cell py-0 "><p className="mb-0 text-center">{item.Descricao}</p></Col>
            {
              item.Condicoes.map((cond, idx) =>
                <Col
                  className={"d-flex justify-content-center column-cell py-0 " +
                    ((cond.pedir == 'S' && cond.tipoPedir == 'A') ? ' bg-success ' : '') +
                    ((cond.pedir == 'S' && cond.tipoPedir == 'M') ? ' bg-info ' : '')}
                  onClick={(e) => {e.detail == 2 && onChangePedir(item.CodBarra, cond.codigo) }}
                >
                  <p className="mb-0 text-center">{cond.valor}</p>

                </Col>
              )
            }
          </Row>
        )}

        <Row className={"border-top border-left border-right border-bottom py-2"}>
          <Col className="d-flex justify-content-center column-cell py-0 font-weight-bold"><p className="mb-0 text-center">Total</p></Col>
          <Col className="d-flex justify-content-center column-cell py-0 "><p className="mb-0 text-center"></p></Col>
          {retorno.itens && retorno.dists.map((dist, idx) =>
            <Col
              className={"d-flex justify-content-center column-cell py-0 "}
            // onClick={() => { onChangePedir(item.CodBarra, cond.codigo) }}
            >
              <p className="mb-0 text-center font-weight-bold">{totalDist(dist.codigo)}</p>
          </Col>
          )}
        </Row>

        {/* </Row> */}
      
    </>
  )
}

export default RetornoSmartPed